export enum AllowedAWSServices {
  cloud9 = 'cloud9',
  ec2 = 'ec2',
  s3 = 's3'
}